module.exports = __webpack_public_path__ + "img/banner-demo-rolex.82365b68.jpg";